import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=0c228570&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=0c228570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c228570",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Login: require('/Users/leo/Desktop/pc/zgszcy/components/login/index.vue').default})
